<template>
  <span
    v-if="label"
    class="badge"
    :style="badgeStyle"
    v-text="label"
  />
</template>

<script>

/**
 * Component: Badge
 * -----------------------------------------------------------------------------
 * - Outputs a simple visual badge.
 * - Variables/classes should be equivalent to the Liquid snippet `util-badge`.
 *
 * @param {String} label - Text to show inside the badge.
 * @param {String} [backgroundColour] - Optional background colour (CSS colour string).
 * @param {String} [textColour] - Optional text colour (CSS colour string).
 */
export default {
  name: 'Badge',

  props: {
    label: {
      type: String,
      required: true,
    },
    backgroundColour: {
      type: String,
      default: '',
    },
    textColour: {
      type: String,
      default: '',
    },
  },

  computed: {

    /**
     * Calculate inline CSS variables for styling the badge.
     * @returns {Object}
     */
    badgeStyle() {
      const style = {}

      if (this.backgroundColour) {
        style['--badge-background-colour'] = this.backgroundColour
      }

      if (this.textColour) {
        style['--badge-text-colour'] = this.textColour
      }

      return style
    },
  },
}
</script>
